import React from 'react';
import { X } from 'lucide-react';
import { notesContent } from '../data/notes';

export default function NotesModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="notes-overlay" onClick={onClose}>
      <div className="notes-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="notes-header">
          <span>Notes</span>
          <button className="icon-btn" onClick={onClose} aria-label="Close" type="button">
            <X size={16} />
          </button>
        </div>
        <pre className="notes-body">{notesContent}</pre>
      </div>
    </div>
  );
}
